import React, { useEffect, useState } from 'react'
import { Box, Button, Tab, Tabs } from '@mui/material'
import { Item } from '../../../../common/snippets'
import DebitCreditBranch from './DebitCreditBranch'
import DebitCreditParty from './DebitCreditParty'
const DebitCreditTab = () => {
    const [senderSect] = useState(['DEBIT/CReDIT BRANCH', 'DEBIT/CREDIT PARTY'])
    const [senderSectContent, setSenderSectContent] = useState(0)

    const handleSenderSect = (event, newValue) => {
        setSenderSectContent(newValue)
    }
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        }
    }
  return (
    <>
    <Item
        sx={{
            width: '100%',
            margintTop: '10px',
            padding: '0px',
            paddingLeft:'17px'
            //   paddingLeft: '19px',
            //  marginRight: '25px',
        }}
    >
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={senderSectContent} onChange={handleSenderSect} aria-label="bsic tabs example">
                {senderSect.map((reqType, index) => (
                    <Tab key={`sender_${index}`} label={reqType} {...a11yProps(index)} style={{ lineHeight: '2.5' }} />
                ))}
            </Tabs>
        </Box>
    </Item>
    {senderSectContent === 0 ? <DebitCreditBranch /> : ''}
    {senderSectContent === 1 ? <DebitCreditParty /> : ''}
    {/* {senderSectContent === 2 ? <VoucherReports /> : ''} */}
</>
  )
}

export default DebitCreditTab